var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.55,
    height: 15.93,
    viewBox: "0 0 16.55 15.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.9;}.cls-2{fill:#d7bb2a;stroke:#d7bb2a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.93,5.27a.7.7,0,0,1,.63.39l2,4.1,4.52.66a.7.7,0,0,1,.57.49.69.69,0,0,1-.17.72L17.2,14.82l.8,4.51a.7.7,0,0,1-.28.69.71.71,0,0,1-.74.06L12.93,18l-4,2.13a.72.72,0,0,1-.8-.13.74.74,0,0,1-.28-.69l.77-4.51L5.35,11.63a.7.7,0,0,1,0-1,.71.71,0,0,1,.4-.21l4.53-.66,2-4.1A.7.7,0,0,1,12.93,5.27Zm0,2.31-1.56,3.14a.69.69,0,0,1-.53.39l-3.47.51,2.51,2.45a.68.68,0,0,1,.2.62l-.59,3.46,3.11-1.63a.7.7,0,0,1,.66,0l3.1,1.63-.59-3.46a.69.69,0,0,1,.21-.62l2.51-2.45L15,11.11a.69.69,0,0,1-.53-.39Z",
    transform: "translate(-4.64 -4.77)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.a4672f01db026def2b933b6020d16b2d.svg";
export { ForwardRef as ReactComponent };